
import { defineComponent } from 'vue';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'QuantityInput',
  components: {
    MinusOutlined,
    PlusOutlined
  },
  data(): { value: string } {
    return {
      value: this.quantity.toString()
    };
  },
  props: {
    quantity: {
      type: Number,
      required: true,
      default: 1
    }
  },
  emits: ['quantity-change'],
  methods: {
    substract() {
      const quantity = Number(this.value);
      if (!isNaN(quantity) && quantity > 1) {
        this.value = String(quantity - 1);
        this.handleChange();
      }
    },
    add() {
      const quantity = Number(this.value || 0);
      if (quantity < 9999) {
        this.value = String(quantity + 1);
        this.handleChange();
      }
    },
    handleChange() {
      const quantity = +this.value;
      if (quantity > 9999) {
        this.value = '9999';
      }
      if (quantity === 0) {
        this.value = '1';
      }
      this.$emit('quantity-change', +this.value);
    }
  }
});
